<template>
  <v-dialog
    scrollable
    persistent
    v-model="show"
    max-width="400px"
    content-class="rounded-xl"
  >
    <v-overlay class="justify-center align-center" v-if="loading">
      <v-progress-circular
        :size="100"
        :width="8"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <v-card v-else :outlined="$vuetify.theme.dark" rounded="xl">
      <v-card-title class="d-flex justify-space-between">
        <div class="text-h6">
          {{ type === $keys.EDIT ? "Edit" : "Add" }} Document
        </div>
        <v-btn icon @click="modalClosed">
          <v-icon size="26">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form class="pt-5" lazy-validation ref="form">
          <v-text-field
            v-model="form.name"
            label="Service Name"
            :rules="[$rules.required]"
            height="42px"
            type="text"
            outlined
            dense
          ></v-text-field>

          <v-select
            :menu-props="{
              bottom: true,
              offsetY: true,
            }"
            append-icon="mdi-chevron-down"
            v-model="form.type"
            :items="service_types"
            :rules="[$rules.required]"
            item-text="value"
            item-value="key"
            flat
            outlined
            dense
            label="Service Type"
          ></v-select>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="submit"
          :loading="btnLoading"
          color="primary"
          class="text-capitalize px-8 my-2"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      btnLoading: false,

      form: {
        name: "",
        type: this.$keys.EDUCATIONAL_DOCUMENTATION,
        is_active: true,
      },
    };
  },

  watch: {
    show(value) {
      if (value) {
        this.openModal();
      } else this.modalClosed();
    },
  },

  computed: {
    ...mapGetters({
      service_types: "getServiceTypes",
      addUpdateService: "admin/addUpdateService",
    }),

    show: {
      get() {
        return this.addUpdateService.show;
      },
      set(value) {
        this.toggleAddUpdateService({ show: value });
      },
    },

    type() {
      return this.addUpdateService.type;
    },
  },
  methods: {
    ...mapActions({
      showSnackbar: "snackBar/showSnackbar",
      toggleAddUpdateService: "admin/toggleAddUpdateService",
    }),

    async openModal() {
      this.loading = true;

      if (this.type === this.$keys.EDIT) {
        await this.getServiceDetail();
      }

      this.loading = false;
    },

    modalClosed() {
      this.$refs.form.reset();
      this.form = {
        name: "",
        type: this.$keys.EDUCATIONAL_DOCUMENTATION,
        is_active: true,
      };
      this.toggleAddUpdateService({ show: false });
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.btnLoading = true;

        const data = { ...this.form };

        const onSuccess = (res) => {
          this.showSnackbar({
            text: res.data.message,
            color: "success",
          });
          this.modalClosed();
          this.$emit("submitted");
        };

        const onFinally = () => {
          this.btnLoading = false;
        };

        if (this.type === this.$keys.EDIT) {
          const params = {
            service_id: this.addUpdateService.id,
          };

          return this.$request(
            this.$keys.PATCH,
            this.$urls.master.service.update,
            {
              params,
              data,
              onSuccess,
              onFinally,
            }
          );
        } else {
          return this.$request(
            this.$keys.POST,
            this.$urls.master.service.create,
            {
              data,
              onSuccess,
              onFinally,
            }
          );
        }
      } else {
        this.$nextTick(() => {
          const el = document.getElementsByClassName("v-input error--text");
          if (el)
            el[0].scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
          return;
        });
      }
    },

    getServiceDetail() {
      const onSuccess = (res) => {
        const data = res.data.data;
        this.form.name = data.name;
        this.form.type = data.type;
        this.form.is_active = data.is_active;
      };

      const params = {
        service_id: this.addUpdateService.id,
      };

      return this.$request(this.$keys.GET, this.$urls.master.service.detail, {
        params,
        onSuccess,
      });
    },
  },
};
</script>
